//
import CostCenterModel from '@/models/Accounting/AccCostCenter'
import PaymentConditionModel from '@/models/Purchase/PchPaymentCondition'
import ProviderModel from '@/models/Purchase/PchProvider'

//
export default [

    /**
     * 
     */
    {
        field       : 'pch_provider_id',
        type        : 'model-auto-complete',
        vuetifyProps: {
            label   : 'Proveedor',
            itemText: 'business_name',
            itemValue: 'id',
            model   : ProviderModel,
            noObject: true,
            readonly: true,
        },
        value       : '',
        rules       : [ 'required' ],
    },
    {
        field       : 'pch_provider_branch_offices_id',
        type        : 'autocompleteObject',
        vuetifyProps: {
            label   : 'Sucursal',
        },
        options: {
            data    : [],
            text    : 'address',
            value   : 'id',
        },
        rules       : [ 'required' ],
    },
    {
        field       : 'invoice_number',
        type        : 'text',
        value       : '',
        vuetifyProps: {
            label   : 'N° de factura',
        },
        rules       : ['required'],
    },
    {
        field       : 'pch_payment_condition_id',
        type        : 'model-auto-complete',
        vuetifyProps: {
            label       : 'Método de pago',
            itemText    : 'type',
            itemValue   : 'id',
            model       : PaymentConditionModel,
            noObject    : true,
            paramSearch : 'type',
            readonly    : true,
        },
        value       : '',
        rules       : [ 'required' ],
    },

    /**
     * 
     */
    {
        field       : 'authorization_date',
        type        : 'datePicker',
        value       : '',
        vuetifyProps: {
            label   : 'Fecha autorización',
        },
        rules       : [ 'required' ],
    },
    {
        field       : 'receiving_date',
        type        : 'datePicker',
        value       : '',
        vuetifyProps: {
            label   : 'Fecha recepción',
        },
        rules       : [ 'required' ],
    },
    {
        field       : 'emission_date',
        type        : 'datePicker',
        value       : '',
        vuetifyProps: {
            label   : 'Fecha emisión',
        },
        rules       : [ 'required' ],
    },
    {
        field       : 'payment_date',
        type        : 'datePicker',
        value       : '',
        vuetifyProps: {
            label   : 'Fecha pago',
        },
        rules       : [ 'required' ],
    },

    /**
     * 
     */
    {
        field       : 'acc_cost_center_id',
        type        : 'model-auto-complete',
        vuetifyProps: {
            label       : 'Centro costo',
            itemText    : 'name',
            itemValue   : 'id',
            model       : CostCenterModel,
            noDataText  : 'No se encontraron centros de costo.',
            noObject    : true,
            paramSearch : 'name',
        },
        value       : '',
        rules       : [ 'required' ],
    },
    {},
    {
        field       : 'new_subtotal',
        type        : 'text',
        maxLength   : 15,
        format      : 'currency',
        value       : '',
        vuetifyProps: {
            label   : 'Neto',
            readonly: true,
        },
        rules       : [ 'required' ],
    },
    {
        field       : 'iva',
        type        : 'text',
        maxLength   : 15,
        format      : 'currency',
        value       : '',
        vuetifyProps: {
            label   : 'IVA',
            readonly: true,
        },
        rules       : [ 'required' ],
    },
    {
        field       : 'total',
        type        : 'text',
        maxLength   : 18,
        format      : 'currency',
        value       : '',
        vuetifyProps: {
            label   : 'Total',
            readonly: true,
        },
        rules       : [ 'required' ],
    },
    {},
    {
        field       : 'is_exent',
        type        : 'checkbox',
        value       : false,
        vuetifyProps: {
            label   : 'Factura exenta',
            readonly: true,
        },
    },
    {
        field       : 'payable',
        type        : 'checkbox',
        value       : false,
        vuetifyProps: {
            falseValue  : true,
            label       : 'Bloquear pago',
            readonly    : true,
            trueValue   : false,
        },
    },
]
